module.exports = __webpack_public_path__ + "img/socialjet.8473f66e.png";